import { useQuery } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import React, { FC, memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useParams } from 'react-router-dom';

import config from 'config/config';
import { Heading1 } from 'uikit/Heading';
import categoryIcon from 'uikit/Icons/Categories';
import routes from 'utils/routeTranslator';

import { L4CategoryCitiesQuery, groupCities, L4CategoryCitiesData } from './CategoryCities.helpers';
import './CategoryCities.scss';
import CategoryRegion from './CategoryRegion/CategoryRegion';

const L4CategoryCities: FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { data, loading, error } = useQuery<L4CategoryCitiesData>(L4CategoryCitiesQuery, {
    variables: {
      slug,
    },
  });

  if (loading) return null;
  if (!data) throw error;

  const groupedCities = groupCities(data.locationSuggestBigCities);
  const { name, ogDescription, l2 } = data.l4BySlug;

  const metaTitle = [t`Wybór miejscowości`, name, config.SITE_NAME].join(' - ');

  return (
    <div className="categoryCities">
      <Helmet>
        <title>{metaTitle}</title>
        <meta property="og:description" content={ogDescription} />
        <meta name="description" content={ogDescription} />
        <link rel="canonical" href={config.SITE_URL + routes.get('front::category.cities', { slug })} />
      </Helmet>

      <Link to={routes.get('front::categories.type', { slug: l2.slug })} className="categoryCities__breadcrumb">
        <span className="categoryCities__breadcrumbIcon">{categoryIcon(l2.slug)}</span>
        {l2.name}
      </Link>
      <Heading1 className="categoryCities__title">
        {name} - <Trans>Wybierz miejscowość</Trans>
      </Heading1>
      {Object.values(groupedCities).map((region) => (
        <div className="categoryCities__region" key={region.region.name}>
          <CategoryRegion region={region} categorySlug={slug} />
        </div>
      ))}
    </div>
  );
};

export default memo(L4CategoryCities);
